/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './assets/sass/index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
